import React from 'react';
import { Controller } from 'react-hook-form';
import { renderTextField as RenderTextField } from 'components/form/field/redux-field';
import { IControlledFormField } from '../types';

interface IProps extends IControlledFormField {
  percentWith?: number;
  onKeyUp?: any;
  inputProps?: any;
}

export const ControlledText: React.FC<IProps> = (props: IProps): JSX.Element => {
  return (
    <Controller
      defaultValue={props.defaultValue}
      control={props.control}
      name={props.name}
      rules={props.validations || {}}
      render={(ctrlProps: any) => (
        <RenderTextField
          width={props.percentWith && `${props.percentWith}%`}
          label={props.label}
          disabled={props.disabled}
          input={{
            value: ctrlProps?.field?.value,
            onChange: ctrlProps?.field?.onChange,
            onBlur: ctrlProps?.field?.onBlur,
          }}
          meta={props.inputMetaData || {}}
          placeholder={props.placeholder}
          data-qa-id={props.qaId}
          onKeyUp={props.onKeyUp}
          inputProps={props.inputProps}
        />
      )}
    />
  );
};
